import React from "react";

export default function RefundPolicy() {
  return (
    <main className="container">
      <section className="request">
        <h2>Refund & Cancellation Policy</h2>
        <p className="sub">
          Effective date: <strong>December 21, 2025</strong>
        </p>

        <div className="grid-1">
          <h3 style={{ color: "var(--ua-blue)" }}>Cancellations</h3>
          <ul>
            <li>
              To cancel or reschedule, contact us at{" "}
              <strong>service@azfacilitymanagement.com</strong>.
            </li>
            <li>
              Timing and fees may depend on scheduling, materials, or work
              already performed.
            </li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>Refunds</h3>
          <ul>
            <li>
              Refund eligibility depends on the service type and whether work
              has begun.
            </li>
            <li>
              If a refund is approved, it is issued to the original payment
              method when possible.
            </li>
            <li>
              Processing times can vary depending on the payment processor.
            </li>
          </ul>

          <h3 style={{ color: "var(--ua-blue)" }}>Disputes</h3>
          <p>
            If you believe there is an error with a charge, contact us first so
            we can resolve it quickly.
          </p>

          <div className="card" style={{ maxWidth: 900 }}>
            <div className="card-body">
              <h3>Need Help?</h3>
              <p>Email: <strong>service@azfacilitymanagement.com</strong></p>
              <p>
                Please include your name, service date (if any), and a brief
                description of the issue.
              </p>
            </div>
          </div>

          <p className="contact-note">
            This policy is provided for transparency and may be updated. The
            latest version will always be posted on this page.
          </p>
        </div>
      </section>
    </main>
  );
}